
import {
  Award,
  Clock,
  Shield,
  Sparkles,
  Star,
  ThumbsUp,
  Zap
} from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import '../../../../assets/css/subscreens/customer/aboutus/whychooseus/WhyChooseUs.css';


const FEATURES = [
  {
    icon: <Shield size={32} />,
    title: 'Verified Professionals',
    description: 'All service providers are background checked, verified, and trained to deliver quality work',
    color: '#0491e1'
  },
  {
    icon: <Star size={32} />,
    title: 'Top Rated Services',
    description: 'Access only 4.5+ rated professionals with proven track records and excellent reviews',
    color: '#f59e0b'
  },
  {
    icon: <Clock size={32} />,
    title: 'On-Time Guarantee',
    description: 'Your service will be delivered as scheduled or we compensate you for the delay',
    color: '#10b981'
  },
  {
    icon: <ThumbsUp size={32} />,
    title: 'Quality Assured',
    description: '100% satisfaction guaranteed with free rework if you are not happy with the service',
    color: '#8b5cf6'
  },
  {
    icon: <Award size={32} />,
    title: 'Best Prices',
    description: 'Competitive pricing with transparent quotes and no hidden charges ever',
    color: '#ef4444'
  },
  {
    icon: <Zap size={32} />,
    title: 'Instant Booking',
    description: 'Book services in seconds with our easy-to-use platform and get instant confirmation',
    color: '#0491e1'
  }
];



const WhyChooseUs = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeFeature, setActiveFeature] = useState(0);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveFeature((prev) => (prev + 1) % FEATURES.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="wcu-section" ref={sectionRef}>
      
      {/* Background Elements */}
      <div className="wcu-bg-pattern" />
      <div className="wcu-bg-circle wcu-bg-circle--1" />
      <div className="wcu-bg-circle wcu-bg-circle--2" />
      <div className="wcu-bg-circle wcu-bg-circle--3" />

      <div className="wcu-container">

        {/* ═══ HEADER ═══ */}
        <div className={`wcu-header ${isVisible ? 'wcu-fade-in' : ''}`}>
          <div className="wcu-badge">
            <Sparkles size={16} />
            <span>WHY CHOOSE US</span>
          </div>
          
          <h2 className="wcu-title">
            Why Pics4Tips is Your Best Choice
          </h2>
          
          <p className="wcu-subtitle">
            We combine reliability, quality, and affordability to give you the best home service experience
          </p>
        </div>

        {/* ═══ FEATURES GRID ═══ */}
        <div className={`wcu-features ${isVisible ? 'wcu-stagger' : ''}`}>
          {FEATURES.map((feature, index) => (
            <div
              key={index}
              className= "wcu-feature-card "
              style={{ animationDelay: `${index * 0.1}s` }}
          
            >
              <div 
                className="wcu-feature-icon"
                style={{ 
                  background: `linear-gradient(135deg, ${feature.color}15 0%, ${feature.color}08 100%)`,
                  borderColor: `${feature.color}30`
                }}
              >
                <div style={{ color: feature.color }}>
                  {feature.icon}
                </div>
              </div>
              
              <h3 className="wcu-feature-title">{feature.title}</h3>
              <p className="wcu-feature-desc">{feature.description}</p>
              
              {/* <div className="wcu-feature-glow" style={{ background: feature.color }} /> */}
            </div>
          ))}
        </div>

       
      </div>
    </section>
  );
};

export default WhyChooseUs;